import React, { ChangeEventHandler } from 'react';
import { TextareaAutosize, TextField } from '@mui/material';
import { FormikTouched } from 'formik/dist/types';

type Props = {
    name: any;
    placeholder?: string;
    required: false | boolean;
    value?: string | undefined;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    type?: 'text' | 'big-text';
};

const FieldTextAreaAutoSize = ({
    name,
    placeholder,
    required,
    value,
    touched,
    errors,
    onChange,
    type = 'text',
}: Props) => {
    return (
        <TextField
            id={name}
            fullWidth
            name={name}
            required={required}
            value={value}
            placeholder={placeholder}
            helperText={touched ? errors : ''}
            error={touched && Boolean(errors)}
            onChange={onChange}
            InputProps={
                type === 'text'
                    ? {
                        inputProps: {
                            style: {
                                fontFamily: 'Lucida Sans',
                                fontSize: '15px',
                            },
                        },
                    }
                    : {
                        inputComponent: TextareaAutosize,
                        inputProps: {
                            style: {
                                height: '150px',
                                fontFamily: 'Lucida Sans',
                                fontSize: '15px',
                            },
                        },
                    }
            }
            sx={{
                width: '80%',
                '.MuiFormHelperText-root': {
                    textAlign: 'center',
                },
            }}
        />
    );
};

export default FieldTextAreaAutoSize;
